module.exports = __webpack_public_path__ + "img/bus_banner.0f2d4958.jpg";